import dayjs from 'dayjs';

export const UPCOMING_DAYS_OPTIONS = [7, 15, 30, 60, 90];

// Tela onde o usuário resolve cada alerta do dashboard (chaves definidas pela API)
export const ALERT_ROUTES: Record<string, string> = {
    'contracts-expiring': '/contratos',
    'biddings-opening': '/licitacoes',
    'expired-banners': '/banners',
    'biddings-without-files': '/licitacoes',
    'contracts-without-files': '/contratos',
    'scheduled-news': '/noticias',
};

// Alertas de pendência (warning) x informativos (info)
export const ALERT_SEVERITY: Record<string, 'warning' | 'info'> = {
    'contracts-expiring': 'warning',
    'biddings-opening': 'info',
    'expired-banners': 'warning',
    'biddings-without-files': 'warning',
    'contracts-without-files': 'warning',
    'scheduled-news': 'info',
};

export function percentOf(part: number, total: number): number {
    if (!total) return 0;
    return Math.round((part / total) * 100);
}

// Dias entre a data de referência e a data informada (negativo quando já passou)
export function daysUntil(date: string | undefined, reference: string | Date): number | undefined {
    if (!date) return undefined;
    return dayjs(date).startOf('day').diff(dayjs(reference).startOf('day'), 'day');
}

export function daysUntilLabel(days: number | undefined): string {
    if (days === undefined) return '';
    if (days < 0) return `vencido há ${Math.abs(days)} dia(s)`;
    if (days === 0) return 'hoje';
    if (days === 1) return 'amanhã';
    return `em ${days} dias`;
}
